import { useState } from "react";
import DeviceDiscovery from "../components/DeviceDiscovery";
import DevicePreSubmission from "../components/DevicePreSubmission";
import GraphViewer from "../components/GraphViewer";
import PDLocator from "../components/PDLocator";
import ContentTitle from "../layout/ContentTitle";

const PredicateFinder = () => {
  const [activeTab, setActiveTab] = useState("locator");
  const tabs = [
    {
      id: "locator",
      label: "Locator",
      content: <PDLocator />,
      tooltip:
        "Locate predicate devices consistent with your device description",
    },
    {
      id: "graph",
      label: "Navigator",
      content: <GraphViewer />,
      tooltip:
        "Insight into the regulatory landscape surrounding your selected device type",
    },
    {
      id: "deviceDiscovery",
      label: "DeviceDiscovery",
      content: <DeviceDiscovery />,
      tooltip: "Access device listings based on your device code",
    },
    {
      id: "devicePreSubmission",
      label: "DevicePreSubmission",
      content: <DevicePreSubmission />,
      tooltip:
        "Create a draft Pre-Submission Letter using your chosen predicate devices",
    },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="flex h-[calc(100vh-40px)] w-full flex-col">
      <ContentTitle title={"Predicate Finder"} />

      <div className="tabs tabs-boxed mt-4 relative">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`
              tab m-1
              text-sm md:text-base
              tracking-wide
              transition-all duration-300 ease-in-out
              ${isActive
                  ? `
                    tab-active
                    scale-105
                    font-bold
                    bg-base-300
                    text-primary/80
                    border-b-4 border-primary
                    shadow-md
                  `
                  : `
                    font-medium
                    text-base-content
                    opacity-90
                    border border-transparent
                    bg-base-200
                    hover:opacity-100
                    dark:bg-base-300
                  `
                }
            `}
            >
              <span className="tooltip tooltip-bottom flex w-full h-full items-center justify-center" data-tip={tab.tooltip}>
                {tab.label}
              </span>
            </button>
          );
        })}

        {/* Info text */}
        <span className="absolute right-0 mt-5 mr-3 text-xs text-gray-500">
          ⓘ This excludes 510(k) exempt devices. Also, note that some PMA
          devices carry empty regulation number.
        </span>
      </div>

      <div className="card bg-base-100 mt-1 flex flex-1 flex-col overflow-hidden p-1 shadow-xl">
        {tabs.find((tab) => tab.id === activeTab)?.content}
      </div>
    </div>
  );
};

export default PredicateFinder;
